module.exports = __webpack_public_path__ + "img/reference47.3c73b56c.jpg";